<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start">
                <strong>{{ $t('sidebars.terminals') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" class="mr-1 ml-1"  size="sm" color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>
                <a :href="$route.fullPath" target="_blank">
                  <CButton
                          class="mr-1 ml-1"
                          size="sm"
                      color="dark"
                  >
                    <CIcon size="sm" name="cil-plus"></CIcon>
                  </CButton>
                </a>
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>

              <CCol sm="4">
                <CRow form class="form-group" >
                  <CCol tag="label" sm="3" class="col-form-label">
                    {{$t('components.searchUser')}}
                  </CCol>
                  <CCol sm="9" :class="key % 2 === 1 ? 'form-inline' : ''">
                    <treeselect
                        v-model="document_person"
                        :options="searched_person"
                        @input="search_user_async = true"
                        :async="search_user_async"
                        :load-options="load_persons"
                        :placeholder="$t('components.searchUser')"
                        :normalizer="normalizer_persons"
                    />

                  </CCol>
                </CRow>



              </CCol>
              <CCol col="4">
                <CInput
                    :label="$t('components.terminalTitle')"
                    horizontal
                    v-model="name"

                />
              </CCol>
              <CCol col="4">
                <CSelect
                    :label="$t('components.bank')"
                    :options="bank_items"
                    :value.sync="selected_bank"
                    horizontal
                />

              </CCol>
<!--              <CCol col="4">-->
<!--                <CSelect-->
<!--                    :label="$t('components.branch')"-->
<!--                    :options="branch_items"-->
<!--                    :value.sync="selected_branch"-->
<!--                    horizontal-->
<!--                />-->

<!--              </CCol>-->

              <CCol col="4">
                <CInput
                    :label="$t('components.terminalCode')"
                    horizontal
                    @keypress="isNumber"
                    v-model="terminal_no"

                />

              </CCol>
              <CCol col="4">
                <CInput
                    :label="$t('components.summary')"
                    horizontal
                    v-model="description"

                />
              </CCol>
              <CCol col="4" v-if="get_access('pc_pos')">
                <CInput
                    label="IP"
                    horizontal
                    v-model="terminalIP"
                />
              </CCol>
              <CCol col="4"  v-if="get_access('pc_pos')">
                <CInput
                    label="Port"
                    horizontal
                    v-model="terminalPort"
                />
              </CCol>
              <CCol col="4">
                <CSelect
                    :options="[{label:$t('active'),value:39},{label:$t('deactivate'),value:40}]"
                    :label="$t('components.status')"
                    :value.sync="status_value"
horizontal
                />
              </CCol>

            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('sidebars.terminals') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="3">
                <CSelect :options="[{label:$i18n.t('all'),value:0},{label:$i18n.t('active'),value:39},{label:$i18n.t('deactivate'),value:40}]"
                         :value.sync="filter_status"
                         :label="$t('tables.status')"
                         horizontal
                />
              </CCol>

            </CRow>
            <CDataTable
                :items="items"
                :fields="fields"
border
                column-filter
                striped
                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item,index}">

                <td style="text-align: center">
                  <p >{{ index + 1 }}</p>

                </td>

              </template>
              <template #accountCode="{item}">

                <td>
                  <p class="text-center">{{ item.accountCode}}</p>

                </td>

              </template>
              <template #summary="{item}">

                <td>
                  <p v-if="item.summary != 'null'">{{ item.summary }}</p>

                </td>

              </template>
              <template #isActive="{item,index}">
                <td style="text-align: center">
                  <CIcon

                      v-if="item.isActive==39"
                      class="text-success" name="cil-check"/>
                  <CIcon

                      v-else
                      name="cil-check"/>
                </td>
              </template>

              <template #isCashier="{item}">

                <td>
                  <div >
                    {{ get_type(item) }}
                  </div>
                </td>

              </template>
              <template #operation="{item}">
                <td>

                  <CButton
                      class="m-1"
                      color="warning"
                      variant="outline"
                      square
                      size="sm"
                      :title="$t('buttons.delete')"
                      @click="edit_item(item)"
                  >
                    <CIcon name="cilPencil"/>
                  </CButton>
                  <CButton
                      class="m-1"
                      color="danger"
                      variant="outline"
                      square
                      size="sm"
                      :title="$t('buttons.delete')"
                      @click="delete_item_dialog(item)"
                  >
                    <CIcon name="cilTrash"/>
                  </CButton>

                </td>
              </template>


            </CDataTable>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
var simulateAsync=null
const simulateAsyncOperation = fn => {
  if(simulateAsync!=null){
    clearTimeout(simulateAsync)
  }
  simulateAsync =  setTimeout(fn, 1000)
}
var items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      filter_status:0,
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      status_value:39,

      validate_errors: [],
      name: '',
      description: '',
      selected_branch: '',
      selected_bank: '',
      terminal_no: '',
      sheba_no: '',
      terminalIP: '',
      terminalPort: '',

      branch_items: [],
      bank_items: [],
      searched_person:[],

      search_user_async :true,

      document_person: null,
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros:true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {
                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },
      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:10%'},
        {key: 'accountCode', label: this.$t('tables.bankAccCode'), _style: 'width:10%'},
        {key: 'terminalTitle', label: this.$t('components.terminalTitle'), _style: 'width:10%'},
        {key: 'bankAccountName', label: this.$t('tables.bank'), _style: 'width:10%'},

        {key: 'terminalCode', label: this.$t('components.terminalCode'), _style: 'width:10%'},
        // {key: 'userName', label: this.$t('tables.user'), _style: 'width:10%'},
        {key: 'branchName', label: this.$t('tables.branch'), _style: 'width:10%'},
        {key: 'isActive', label: this.$t('tables.status'), _style: 'width:5%'},

        {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'),sorter:false, _style: 'width:20%;'},
      ],

      cashier_types:[
        {label:this.$t('components.cashier'),value:true},
        {label:this.$t('components.salary'),value:true}
      ],
      selected_cashier_type:true,
      status_form: 0,

    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];

    this.get_bank();
    this.get_branches();
    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'filter_status':function (){
      this.get_lists()
    },
    '$route.params.cat_id': function () {
      this.get_lists();
    },

  },
  methods: {
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.selected_branch != 0
          && this.terminal_no != ''  && this.name != '') {
        return true;
      }


      if (this.selected_branch == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectBranch'));
      }

      if (this.terminal_no == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertTerminalNo'));
      }
      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertTerminalName'));
      }

      return false;
      // e.preventDefault();
    },

    get_type(item) {
      if(item.isCashier){
        return this.$t('components.cashier')
      }else{
        return this.$t('components.salary')

      }

    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.terminalTitle;
      this.description = item.summary;
      this.selected_branch = item.branchId;
      this.selected_bank = item.bankAccountId;
      this.terminal_no = item.terminalCode;
      this.sheba_no = item.methodColor;
      this.search_user_async =false;
      this.status_value = item.isActive

      this.terminalIP= item.terminalIP;
      this.terminalPort= item.terminalPort;
      this.selected_cashier_type= item.isCashier
      this.searched_person = [{
        userId: item.userId,
        userName: item.userName,
        personCode : '',
        surName : '',
        mobileNo : '',
      }];
      this.document_person = item.userId;
      this.search_user_async =false;

      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;
      this.search_user_async = true;
      this.document_person = null;
      this.name = null;
      this.description = null;
      this.selected_branch = null;
      this.selected_bank = null;
      this.terminal_no = null;
      this.sheba_no = null;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      formData.append('StatusId', this.filter_status);


      axios.post('GetBankTerminals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_bank() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankAccounts', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bank_items = [{label:self.$t('select'),value:0}];
          content_data.data.forEach((val) => {
            var obj = {label: val.bankAccTitle, value: val.id}

            self.bank_items.push(obj);
          });
          self.selected_bank = self.bank_items[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_branches() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.branch_items = [];
          self.branch_items = self.sort_array(
                  self.branch_items, content_data.data,
                  'branchId','branchTitle');


          self.selected_branch = self.branch_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

        // self.description = '';
        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goToMembers(item) {

      this.$router.push({path: '/dashboard/accounting/sale-method-members/' + item.id});

    },

    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddBankTerminal";
      } else {
        url = "EditBankTerminal";
        formData.append('Id', this.status_form)

      }


      formData.append('IsActive', this.status_value);
      formData.append('TerminalIP', this.terminalIP);
      formData.append('TerminalPort', this.terminalPort);
      formData.append('TerminalTitle', this.name);
      formData.append('TerminalCode', this.terminal_no);
      formData.append('BranchId', this.selected_branch);
      formData.append('UserId', this.document_person);
      formData.append('BankAccountId', this.selected_bank);
      formData.append('Summary', this.description);

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {



        self.status_form = 0;
        self.name = '';
        self.bank_no = '';
        self.description = '';
        self.sheba_no = '';
        self.get_lists();
        self.search_user_async = true;
        self.document_person = null;
        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.terminalTitle]), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteBankTerminal";
      formData.append('Id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
